import React, { Component } from 'react';
import { samplesSchema } from '../normalize';

import {
  DataToChart,
  filterSensorsByLoggerId,
  sortByNameAndType
} from '../helper/DataToChart';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment-timezone';
import { updateQueryParams } from '../actions/queryParams';
import { fetchSamples } from '../helper/api';
import { withStyles } from 'material-ui/styles';
import withRouter from 'react-router-dom/es/withRouter';
import ChartCard from '../components/ChartCard';
import { setAppLoadingSamples } from '../actions/loading';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16
  })
});

const getFilterFromUri = ({ match }) =>
  match.params.group && match.params.filter
    ? {
        filterType: match.params.group,
        filter: decodeURIComponent(match.params.filter)
      }
    : null;

class ChartWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      samples: {},
      dataSets: {}
    };
  }

  requestSamples = async ({
    chartOptions,
    siteId,
    loggerId,
    groupFilter,
    timezone,
    sensors,
    queryParams,
    groupFilterRelations,
    filter,
    setAppLoadingSamples,
    loading,
    ...rest
  }) => {
    if (!siteId || !sensors || !groupFilterRelations.updated) {
      return;
    }

    if (loading) {
      return;
    }

    setAppLoadingSamples(true);

    if (loggerId) {
      sensors = filterSensorsByLoggerId({ sensors, loggerId });
    }

    const { meta, samples, error } = await fetchSamples({
      siteId,
      loggerId,
      queryParams,
      samplesSchema,
      filter,
      activeEnergyTypes: chartOptions.activeEnergyTypes,
      ...rest
    });

    const sampleInterval =
      meta && meta.hasOwnProperty('sample_interval') ? meta.sample_interval : 2;

    const datasets = DataToChart({
      chartOptions,
      groupFilterRelations,
      groupFilter,
      timezone,
      samples,
      sensors,
      sampleInterval,
      filter: filter
    });

    this.setState({
      samples: await samples,
      dataSets: datasets,
      emptyResponse: !samples,
      errorResponse: error,
      sampleInterval
    });

    setAppLoadingSamples(false);
  };

  componentWillReceiveProps(nextProps) {
    const loggerId = nextProps.match.params.loggerId;
    const {
      groupFilter,
      queryParams,
      sensors,
      timezone,
      groupFilterRelations,
      chartOptions
    } = nextProps;
    const groupingChanged = groupFilter !== this.props.groupFilter;
    const samplesQueryParamsChanged =
      queryParams.from !== this.props.queryParams.from ||
      queryParams.to !== this.props.queryParams.to ||
      queryParams.aggregationLevel !== this.props.queryParams.aggregationLevel;
    const sensorsChanged =
      !sensors ||
      !this.props.sensors ||
      sensors !== this.props.sensors ||
      Object.keys(sensors).length !== Object.keys(this.props.sensors).length;
    const groupFilterRelationsChanged =
      JSON.stringify(groupFilterRelations) !==
      JSON.stringify(this.props.groupFilterRelations);
    const chartOptionsChanged =
      JSON.stringify(chartOptions) !== JSON.stringify(this.props.chartOptions);

    if (groupingChanged || chartOptionsChanged) {
      const { samples } = this.state;

      const datasets = DataToChart({
        chartOptions,
        groupFilter,
        groupFilterRelations,
        sensors: loggerId
          ? filterSensorsByLoggerId({ sensors, loggerId })
          : sensors,
        timezone,
        samples,
        sampleInterval: this.state.sampleInterval || null
      });

      this.setState({
        dataSets: datasets
      });
    }

    if (
      samplesQueryParamsChanged ||
      sensorsChanged ||
      groupFilterRelationsChanged
    ) {
      this.requestSamples({ ...nextProps, loggerId });
    }
  }

  componentWillMount() {
    const { timezone } = this.props;
    const newQueryParams = {
      from: moment
        .tz(timezone)
        .startOf('day')
        .subtract(7, 'day')
        .unix(),
      to: moment
        .tz(timezone)
        .startOf('day')
        .unix(),
      aggregationLevel: false
    };

    const samplesQueryParamsChanged =
      newQueryParams.from !== this.props.queryParams.from ||
      newQueryParams.to !== this.props.queryParams.to ||
      newQueryParams.aggregationLevel !==
        this.props.queryParams.aggregationLevel;

    if (samplesQueryParamsChanged) {
      this.props.updateQueryParams(newQueryParams);
      return;
    }

    const loggerId = this.props.match.params.loggerId;
    this.requestSamples({ ...this.props, loggerId });
  }

  render() {
    const { dataSets, emptyResponse, errorResponse } = this.state;
    const {
      chartOptions,
      utcOffset,
      queryParams,
      updateQueryParams,
      external,
      loading
    } = this.props;

    if (errorResponse) {
      return <div>{errorResponse.message}</div>;
    }

    const charts = Object.keys(dataSets)
      .sort((a, b) => sortByNameAndType(dataSets[a], dataSets[b]))
      .map(key => (
        <ChartCard
          key={key}
          loading={loading}
          chartOptions={chartOptions}
          timeSeries={dataSets[key]}
          utcOffset={utcOffset}
          queryParams={queryParams}
          updateQueryParams={updateQueryParams}
          external={external}
          emptyResponse={emptyResponse}
        />
      ));

    return (
      <div>
        {charts.length ? charts : loading ? '...Loading samples' : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  chartOptions: state.chartOptions,
  siteId: state.site.id,
  sensors: state.sensors,
  queryParams: state.queryParams,
  groupFilter: state.groupFilter,
  groupFilterRelations: state.groupFilterRelations,
  timezone: state.app.timezone,
  utcOffset: moment.tz(state.site.timezone).utcOffset(),
  loading: state.loading.samples,
  sampleResolution: state.app.appWidth
    ? Math.round(state.app.appWidth / 8)
    : 200,
  filter: getFilterFromUri({ match: ownProps.match })
});

export default connect(mapStateToProps, {
  updateQueryParams,
  setAppLoadingSamples
})(withStyles(styles, { name: 'ChartWrapper' })(withRouter(ChartWrapper)));



// WEBPACK FOOTER //
// ./src/container/ChartWrapper.js